'use client';

import { ShoppingBag, X } from 'lucide-react';

interface CartPreviewHeaderProps {
  itemCount: number;
  isEmpty: boolean;
  onClose: () => void;
}

export function CartPreviewHeader({ itemCount, isEmpty, onClose }: CartPreviewHeaderProps) {
  const headerMessage = isEmpty ? 'Nothing Yet' : `You have ${itemCount} items in your cart`;

  return (
    <div className="flex items-center justify-between py-3 px-3 bg-orange-200">
      <h2 className="font-semibold flex items-center text-orange-700">
        <ShoppingBag className="w-4 h-4 mr-2" />
        <span>{headerMessage}</span>
      </h2>
      <button
        onClick={onClose}
        className="p-1 hover:bg-white/50 rounded-full transition-colors"
        aria-label="Close cart preview">
        <X className="w-5 h-5 text-gray-500" />
      </button>
    </div>
  );
}
